import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckCircle2, Sparkles } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 pb-10 px-4" data-id="element-79">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-80">
        <div className="absolute top-20 left-10 w-72 h-72 bg-purple-600/20 rounded-full blur-[100px] animate-pulse" data-id="element-81" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-500/10 rounded-full blur-[100px] animate-pulse delay-1000" data-id="element-82" />
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-83" />
      </div>

      <div className="container mx-auto relative z-10 max-w-5xl text-center" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8 backdrop-blur-sm" data-id="element-85">
          <Sparkles className="w-4 h-4 text-cyan-400" data-id="element-86" />
          <span className="text-sm font-medium text-cyan-100" data-id="element-87">
            Programa de 15 días
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-5xl md:text-7xl font-extrabold leading-tight mb-6" data-id="element-88">
          EL ARTE DE <br data-id="element-89" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400" data-id="element-90">
            MONETIZAR TUS REDES
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-91">
          Crea y vende tu primer producto digital rentable en solo 15 días.
          Convierte tus ideas en ingresos aunque hoy no sepas qué vender.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-92">
          {['Sin miles de seguidores', 'Sin experiencia técnica', 'Sin productos previos'].map((item, i) => <div key={i} className="flex items-center gap-2 text-gray-400 bg-white/5 px-4 py-2 rounded-lg border border-white/5" data-id="element-93">
              <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-94" />
              <span className="text-sm" data-id="element-95">{item}</span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="flex flex-col items-center gap-6" data-id="element-96">
          <div className="flex items-center gap-4" data-id="element-97">
            <span className="text-gray-500 line-through text-xl" data-id="element-98">$97.00</span>
            <span className="text-4xl font-bold text-white" data-id="element-99">$16.39</span>
            <span className="bg-green-500/20 text-green-400 px-3 py-1 rounded-full text-sm font-bold border border-green-500/30" data-id="element-100">
              -83% OFF
            </span>
          </div>

          <CTAButton size="lg" className="w-full md:w-auto min-w-[300px]" data-id="element-101" />

          <p className="text-sm text-gray-500 mt-2" data-id="element-102">
            Acceso inmediato • Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}